import { parseConfig } from 'constants/defaultValues';
/* eslint-disable */
import Parse from 'parse/dist/parse.min.js';

const waitFor = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export default class ParseHelper {
  static initialized = 'no';

  static async waitToComplete() {
    if (this.initialized === 'running') {
      await waitFor(100);
      return this.waitToComplete();
    }
    return 1;
  }

  static async init() {
    if (this.initialized === 'yes') return;
    if (this.initialized === 'running') {
      await this.waitToComplete();
      return;
    }
    this.initialized = 'running';
    try {
      const { PARSE_APPLICATION_ID, PARSE_CLIENT_KEY, PARSE_URL } = parseConfig;
      await Parse.initialize(PARSE_APPLICATION_ID, PARSE_CLIENT_KEY);
      Parse.serverURL = PARSE_URL;
      this.initialized = 'yes';
    } catch {
      this.initialized = 'failed';
    }
  }

  static async Login(username, password) {
    await this.init();
    try {
      const user = await Parse.User.logIn(username, password);
      return user
        ? { result: true, user, message: 'login successful!' }
        : { result: false, user: null, message: 'login failed!' };
    } catch (err) {
      return this.HandleError(err);
    }
  }

  static async SignUp(username, password, attrs) {
    await this.init();
    try {
      const user = new Parse.User();
      user.set('username', username);
      user.set('password', password);
      user.set(attrs);
      await user.signUp();
      return { result: true, user, message: 'signup successfully!' };
    } catch (error) {
      return { result: false, message: error.message, user: null };
    }
  }

  static async getUserRoles(user) {
    var queries = [new Parse.Query('_Role').equalTo('users', user)];
    for (var i = 0; i < 2; i++) {
      queries.push(new Parse.Query('_Role').matchesQuery('roles', queries[i]));
    }

    user.rolesPromise = await Parse.Query.or
      .apply(Parse.Query, queries)
      .find()
      .then(function (roles) {
        return roles.map(function (role) {
          return role.get('name');
        });
      });
  }

  static async ResetPassword(Email, success, fail) {
    await this.init();
    const res = await this.CloudRun('passwordreset', { email: Email });
    if (res.result) {
      success();
    } else {
      fail(res);
      console.error('Password Reset:', res.message);
    }
  }

  static async VerifyEmail() {
    await this.init();
    return this.CloudRun('verifyemail');
  }

  static async Logout() {
    await this.init();
    try {
      await Parse.User.logOut();
    } catch (err) {
      console.log(err);
    }
  }

  static async AuthenticateMe() {
    await this.init();
    const res = await this.CloudRun('verifysession');
    if (res.result !== true) {
      this.Logout();
    }
    return res;
  }

  static async Authenticate(success, fail) {
    await this.init();
    const res = await this.CloudRun('verifysession');
    if (res.result === true) {
      await success(res.user, res.subscription);
    } else {
      this.Logout();
      fail();
    }
  }

  static async CurrentUser() {
    await this.init();
    const user = await Parse.User.current();
    if (user) return user;
    return false;
  }

  static async SaveObject(obj) {
    const user = await this.CurrentUser();
    try {
      await obj.save(null, { sessionToken: user.getSessionToken() });
      return { result: true, message: 'object saved successfully!' };
    } catch (e) {
      return this.HandleError(e);
    }
  }

  static CreateObject(name, params) {
    this.init();
    return new (Parse.Object.extend(name))(params);
  }

  static Query(ParseObject) {
    this.init();
    return new Parse.Query(ParseObject);
  }

  static ObjectQuery(name) {
    return this.Query(Parse.Object.extend(name));
  }

  static async CloudRun(name, params) {
    await this.init();
    try {
      return await Parse.Cloud.run(name, params);
    } catch (e) {
      return this.HandleError(e);
    }
  }

  static async StitchCredit() {
    await this.init();
    try {
      return await Parse.Cloud.run('StitchPreAuth');
    } catch (e) {
      return this.HandleError(e);
    }
  }

  static async HandleError(err) {
    if (err.code === 209) await this.Logout();
    return { result: false, message: err.message };
  }
}
